import { ICheckedItems } from "types"

export const INITIAL_VALUES_FILTER: ICheckedItems = {
    activos: false,
    correosValidos: false,
    numerosValidos: false,
}
